import { render } from "./ValidationIcon.vue?vue&type=template&id=0f3ad36a"
import script from "./ValidationIcon.vue?vue&type=script&lang=js"
export * from "./ValidationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__